module.exports = __webpack_public_path__ + "img/pr.379f8f65.svg";